export { default as ProductPageOption } from "./ProductPageOption";
